import controller from './summary-block.controller';
import template from './summary-block.html';

export default {
    controller,
    template,
    bindings: {
        onClick: '&?', /* method wich will recieve model */
        model: '<' /* Data: title, diff, current, previous, period */,
        positioning: '@' /* horizontal or vertical */,
        clickable: '<' /* true or false */,
        isActive: '<',
        editable: '<',
        onRemove: '&',
        typeClass:'@?'
    }
};



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/summary-block/summary-block.component.js